export const PERMISSION_KEYS = {
  demand: {
    create: '/gestao/solicitacoes/criar-demanda',
    view: '/gestao/solicitacoes/visualizar-demanda',
    update: '/gestao/solicitacoes/editar-demanda',
    cancel: '/gestao/solicitacoes/cancelar-demanda',
    approve: '/gestao/solicitacoes/aprovar-solicitacao',
    reject: '/gestao/solicitacoes/reprovar-solicitacao',
    list: '/gestao/solicitacoes/listar-demandas',
  },
  serviceOrder: {
    program: '/gestao/ordens-servico/acessar-programa',
    view: '/gestao/ordens-servico/visualizar-ordem-servico',
    update: '/gestao/ordens-servico/atualizar-ordem-servico',
    cancel: '/gestao/ordens-servico/cancelar-ordem-servico',
    list: '/gestao/ordens-servico/listar-ordens-servico',
    markAsExecuted: '/gestao/ordens-servico/marcar-como-executada',
    validateExecution: '/gestao/ordens-servico/validar-execucao',
    rejectExecution: '/gestao/ordens-servico/recusar-execucao',
  },
  approval: {
    program: '/gestao/aprovacoes/acessar-programa',
  },
  technicalVisit: {
    create: '/gestao/visitas/agendar-visita',
    reschedule: '/gestao/visitas/reagendar-visita',
    view: '/gestao/visitas/visualizar-visita',
    list: '/gestao/visitas/listar-visitas',
    accept: '/gestao/visitas/aceitar-visita',
    reject: '/gestao/visitas/recusar-visita',
    cancel: '/gestao/visitas/cancelar-visita',
    confirmDone: '/gestao/visitas/confirmar-visita-realizada',
    confirmNotDone: '/gestao/visitas/confirmar-visita-nao-realizada',
  },
  budget: {
    create: '/gestao/orcamentos/criar-orcamento',
    update: '/gestao/orcamentos/editar-orcamento',
    view: '/gestao/orcamentos/visualizar-orcamento',
    list: '/gestao/orcamentos/listar-orcamentos',
    approve: '/gestao/orcamentos/aprovar-orcamento',
    reject: '/gestao/orcamentos/reprovar-orcamento',
    requestChanges: '/gestao/orcamentos/solicitar-ajuste-orcamento',
    submit: '/gestao/orcamentos/enviar-orcamento',
  },
  user: {
    manage: '/configuracoes/usuarios/gerenciar-usuarios',
  },
  role: {
    manage: '/configuracoes/niveis-acesso/gerenciar-perfis',
  },
  company: {
    view: '/configuracoes/perfil-empresa/visualizar-empresa',
    update: '/configuracoes/perfil-empresa/editar-empresa',
  },
  branch: {
    manage: '/configuracoes/filiais/gerenciar-filiais',
  },
  localProvider: {
    manage: '/configuracoes/prestadores/gerenciar-prestadores-locais',
  },
  matchmakingRules: {
    manage: '/configuracoes/regras/gerenciar-criterios-matchmaking',
    view: '/configuracoes/regras/visualizar-criterios-matchmaking',
  },
  qualification: {
    manage: '/configuracoes/qualificacoes/gerenciar-qualificacoes',
  },
  audit: {
    view: '/relatorios/auditoria/visualizar-auditoria',
  },
  moderation: {
    userAccess: {
      createUser: '/moderacao/usuarios-acessos/criar-usuario',
      viewBindings: '/moderacao/usuarios-acessos/consultar-vinculos',
      updateModerator: '/moderacao/usuarios-acessos/editar-moderador',
      deactivateModerator: '/moderacao/usuarios-acessos/desativar-moderador',
    },
  },
} as const;
